import trim from 'lodash/trim';

import JsonForm, { JsonFormArray, JsonFormType } from '@evidentid/json-schema/interfaces/JsonForm';
import { JsonSchemaEnum } from '@evidentid/json-schema/interfaces/JsonSchema';

import { resolveEnumValue } from '@/utils/enum-labels/enumLabels';

const booleanValues: Record<string, boolean> = { yes: true, no: false };

export function buildValue(
    _value: string | undefined, form: JsonForm,
): string | object | boolean | string[] | object[] | null {
    const value = trim(_value || '');
    const type = form.type;
    if (type === JsonFormType.boolean && value.toLowerCase() in booleanValues) {
        return booleanValues[value.toLowerCase()];
    } else if (type === JsonFormType.object && _value) {
        return _value;
    } else if (type === JsonFormType.array) {
        if (!value.length || value.length === 0) {
            return [];
        }
        const item = (form as JsonFormArray).item;
        if (item.type === JsonFormType.object) {
            // A Download Data cell is one JSON array, read whole so a "|" inside a value survives.
            return value.startsWith('[') ? JSON.parse(value) : value.split('|').map((x) => JSON.parse(x));
        }
        return item.type === JsonFormType.enum
            ? value.split('|').map((x) => resolveEnumValue(item.schema as JsonSchemaEnum, trim(x)))
            : value.split('|').map((x) => trim(x));
    } else if (type === JsonFormType.enum) {
        return value.length === 0 ? null : resolveEnumValue(form.schema as JsonSchemaEnum, value);
    }
    return value;
}
